import { ApiError, apiRequest } from '@/lib/api-client';
import {
  analyticsWindowSchema,
  assertAnalyticsResponseScope,
  investorLiquidityResponseSchema,
  investorRiskResponseSchema,
  normalizeAnalyticsAddress,
  normalizeAnalyticsChainId,
  type AnalyticsWindow,
  type InvestorLiquidity,
  type InvestorRisk
} from './schemas';

export async function fetchInvestorRisk(
  address: string,
  chainId: number,
  window: AnalyticsWindow,
  signal?: AbortSignal
): Promise<InvestorRisk> {
  const investor = normalizeAnalyticsAddress(address);
  const validatedChainId = normalizeAnalyticsChainId(chainId);
  const validatedWindow = analyticsWindowSchema.parse(window);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/risk`,
    investorRiskResponseSchema,
    {
      auth: 'required',
      chainId: validatedChainId,
      query: { window: validatedWindow },
      signal
    }
  );

  assertAnalyticsResponseScope(investor, validatedChainId, response);
  if (response.window !== validatedWindow) {
    throw new ApiError('ROWA returned data that could not be verified.', {
      status: 200,
      code: 'invalid-response'
    });
  }
  return response;
}

export async function fetchInvestorLiquidity(
  address: string,
  chainId: number,
  signal?: AbortSignal
): Promise<InvestorLiquidity> {
  const investor = normalizeAnalyticsAddress(address);
  const validatedChainId = normalizeAnalyticsChainId(chainId);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/liquidity`,
    investorLiquidityResponseSchema,
    { auth: 'required', chainId: validatedChainId, signal }
  );

  assertAnalyticsResponseScope(investor, validatedChainId, response);
  return response;
}
